import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/Layout.vue'

Vue.use(VueRouter)

const lazy = (p) => () => import(/* webpackChunkName: "[request]" */ `@/views/${p}.vue`)

const routes = [
  { path: '/login', name: 'login', component: () => import(/* webpackChunkName: "login" */ '@/views/login/Login.vue') },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      { path: 'home', name: 'home', meta: { title: '首页' }, component: lazy('home/Home') },
      { path: 'system', name: 'system', meta: { title: '系统设置' }, component: lazy('system/System') },
      { path: 'wallet', name: 'wallet', meta: { title: '钱包' }, component: lazy('wallet/Wallet') },
      { path: 'user', name: 'user', meta: { title: '用户管理' }, component: lazy('user/User') },
      { path: 'apply', name: 'apply', meta: { title: '申请管理' }, component: lazy('apply/Apply') },
      { path: 'report', name: 'report', meta: { title: '报表' }, component: lazy('report/Report') },
      { path: 'activity', name: 'activity', meta: { title: '活动管理' }, component: lazy('activity/Activity') },
      { path: 'monitor', name: 'monitor', meta: { title: '现场监控' }, component: lazy('monitor/Monitor') },
      { path: 'quota', name: 'quota', meta: { title: '赔率限额' }, component: lazy('quota/Quota') },
      { path: 'makeoffer', name: 'makeoffer', meta: { title: '打盘报表' }, component: lazy('makeoffer/MakeOffer') },
      { path: 'open', name: 'open', meta: { title: '开奖结果' }, component: lazy('open/Open') },
      { path: 'game', name: 'game', meta: { title: '娱乐游戏' }, component: lazy('game/Game') },
      { path: 'liang', name: 'liang', meta: { title: '靓号活动' }, component: lazy('liang/Liang') }
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({ mode: 'hash', routes })
export default router
